import { useMutation } from "@apollo/client/react";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_PLUGIN_TEMPLATE, GET_PLUGIN_TEMPLATES } from "./gql";

type DeleteConfirmationProps = {
  name: string;
  id: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  name,
  id,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deletePluginTemplate, { loading, data }] = useMutation(DELETE_PLUGIN_TEMPLATE, {
    refetchQueries: [GET_PLUGIN_TEMPLATES],
    awaitRefetchQueries: true,
    variables: { id },
  });

  const handleDeletePluginTemplate = () => {
    deletePluginTemplate()
      .then(() => {
        reportSuccess({
          message: `Plugin template "${name}" was successfully deleted`,
        });
        modal.resolve();
        modal.hide();
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete plugin template"
      onConfirm={handleDeletePluginTemplate}
      isLoading={loading}
      isDismissable={!loading && !data?.pluginTemplateDelete?.id}
    >
      <>
        <ConfirmationModalMessage>
          Are you sure you want to delete the plugin template <strong>{name}</strong>?
        </ConfirmationModalMessage>
        <ConfirmationModalMessage>
          Deleting this plugin template will <strong>not</strong> remove any existing installations
          of the plugin.
        </ConfirmationModalMessage>
      </>
    </DeleteConfirmationModal>
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
